import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/logo-dark.svg'
import _imports_1 from '@/assets/icons/menu.svg'


const _hoisted_1 = { class: "h-full w-full z-50 sticky top-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-20 h-auto"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "h-screen w-screen fixed top-0 left-0 right-0 bottom-0 bg-[url(@/assets/bg-menu.webp)] bg-contain z-10 flex flex-col pt-32"
}
const _hoisted_5 = { class: "flex items-center gap-8 h-full flex-col text-white text-lg font-medium w-full" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "h-0.5 w-16 bg-light-green mx-auto" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "h-0.5 w-16 bg-light-green mx-auto" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "h-0.5 w-16 bg-light-green mx-auto" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "h-0.5 w-16 bg-light-green mx-auto" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-center text-xs leading-6 mt-auto mb-20" }, [
  /*#__PURE__*/_createTextVNode(" Property of 11x12 Solutions Inc. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("All rights reserved. ")
], -1)

import { getCurrentPath } from "@/router/local-router";
import { onUnmounted, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'header-sm',
  setup(__props) {

const currentPath = ref(getCurrentPath());
const updatePath = () => {
  currentPath.value = getCurrentPath();
};
onUnmounted(() => {
  window.addEventListener("pathchange", updatePath);
});
const isActive = ref(false);

const disableScroll = () => {
  console.log("Disabling scroll");
  document.body.style.overflow = "hidden";
  document.body.style.position = "fixed";
  document.body.style.width = "100%";
};

const enableScroll = () => {
  document.body.style.overflow = "";
  document.body.style.position = "";
  document.body.style.width = "";
};
watch(isActive, () => {
  if (isActive.value) {
    disableScroll();
  } else enableScroll();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex items-center w-full px-7 py-1 transition-all delay-200", { 'bg-secondary-gray': !isActive.value, 'bg-transparent': isActive.value }])
      }, [
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isActive.value = false))
        }, _hoisted_3),
        _createElementVNode("img", {
          src: _imports_1,
          class: "ml-auto w-8 h-8",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (isActive.value = !isActive.value))
        })
      ], 2)
    ]),
    _createVNode(_Transition, { name: "bounce" }, {
      default: _withCtx(() => [
        (isActive.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("a", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (isActive.value = false)),
                  href: "#family-space"
                }, "Family Space"),
                _hoisted_6,
                _createElementVNode("a", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (isActive.value = false)),
                  href: "#commercial"
                }, "Commerical"),
                _hoisted_7,
                _createElementVNode("a", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (isActive.value = false)),
                  href: "#putting-greens"
                }, "Putting Greens"),
                _hoisted_8,
                _createElementVNode("a", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (isActive.value = false)),
                  href: "#happy-pets"
                }, "Happy Pets"),
                _hoisted_9,
                _createElementVNode("a", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (isActive.value = false)),
                  href: "#lighting"
                }, "Lighting"),
                _hoisted_10
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})